import React, { useEffect } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import LabeledCheckbox from '../LabeledCheckbox';
import LabeledTextbox from '../LabeledTextbox';

export type AccountCreateFormProps = {
  needAccountToCheckout: boolean;
  isEmailRegistered?: boolean;
};

export const AccountCreateFormTestId = 'AccountCreateForm-input';

const AccountCreateFormWithFormContext: React.FC<AccountCreateFormProps> = ({
  needAccountToCheckout,
  isEmailRegistered = false,
}: AccountCreateFormProps) => {
  const {
    register,
    formState: { errors },
    setValue,
    control,
    clearErrors,
  } = useFormContext<{ password: string; createAccount: boolean }>();

  const createAccountWatch = useWatch({
    control,
    name: 'createAccount',
  });

  useEffect(() => {
    if (createAccountWatch === false) {
      setValue('password', '');
      clearErrors('password');
    }

    if (createAccountWatch === undefined) setValue('createAccount', true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [createAccountWatch]);

  const passwordFieldLabel = `To complete checkout, ${
    isEmailRegistered
      ? 'enter your account password below'
      : 'enter a password below to create an account'
  }${needAccountToCheckout ? '' : ' (OPTIONAL)'}`;

  return (
    <div data-testid={AccountCreateFormTestId} className="flex flex-col">
      {!needAccountToCheckout && !isEmailRegistered ? (
        <LabeledCheckbox
          label="Save my information for a faster checkout"
          name="createAccount"
          register={register}
          defaultChecked={createAccountWatch}
        />
      ) : (
        <div className="ml-4 mt-2 text-xs">{passwordFieldLabel}</div>
      )}

      {createAccountWatch && (
        <LabeledTextbox
          name="password"
          label="Password"
          type="password"
          autoComplete="password"
          maxLength={20}
          errorLabel={errors?.password?.message}
          register={register}
          disabled={!createAccountWatch}
        />
      )}
    </div>
  );
};

export default AccountCreateFormWithFormContext;
